import * as React from 'react'

function SvgOneToOneXSGD(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_209_118965)">
        <ellipse
          opacity="0.2"
          cx="10.7998"
          cy="18.1953"
          rx="9"
          ry="9"
          fill="#00D37E"
        />
        <path
          d="M7.37761 22.3423C7.37761 22.6699 7.25701 22.9363 7.01581 23.1415C6.77461 23.3431 6.45421 23.4439 6.05461 23.4439C5.62621 23.4439 5.27701 23.3683 5.00701 23.2171V22.3801C5.33461 22.6177 5.68381 22.7365 6.05461 22.7365C6.18061 22.7365 6.28501 22.7041 6.36781 22.6393C6.45061 22.5709 6.49201 22.4827 6.49201 22.3747C6.49201 22.3387 6.48661 22.3045 6.47581 22.2721C6.46501 22.2397 6.44521 22.2091 6.41641 22.1803C6.38761 22.1515 6.35881 22.1281 6.33001 22.1101C6.30481 22.0885 6.26521 22.0651 6.21121 22.0399C6.16081 22.0111 6.11761 21.9877 6.08161 21.9697C6.04561 21.9517 5.99161 21.9265 5.91961 21.8941C5.85121 21.8617 5.79541 21.8365 5.75221 21.8185C5.51821 21.7105 5.32921 21.5773 5.18521 21.4189C5.04481 21.2605 4.97461 21.0499 4.97461 20.7871C4.97461 20.4739 5.08981 20.2219 5.32021 20.0311C5.55061 19.8367 5.86921 19.7395 6.27601 19.7395C6.63961 19.7395 6.95281 19.8007 7.21561 19.9231V20.7007C6.92401 20.5315 6.62161 20.4469 6.30841 20.4469C6.16801 20.4469 6.06001 20.4757 5.98441 20.5333C5.91241 20.5909 5.87641 20.6647 5.87641 20.7547C5.87641 20.8447 5.92141 20.9257 6.01141 20.9977C6.10141 21.0661 6.23641 21.1399 6.41641 21.2191C6.52801 21.2695 6.61981 21.3145 6.69181 21.3541C6.76741 21.3901 6.85201 21.4423 6.94561 21.5107C7.04281 21.5755 7.11841 21.6457 7.17241 21.7213C7.23001 21.7933 7.27861 21.8833 7.31821 21.9913C7.35781 22.0993 7.37761 22.2163 7.37761 22.3423Z"
          fill="#00D37E"
        />
        <path
          d="M11.0262 23.0659C10.6806 23.3179 10.245 23.4439 9.71944 23.4439C9.13624 23.4439 8.66284 23.2765 8.29924 22.9417C7.93564 22.6069 7.75384 22.1515 7.75384 21.5755C7.75384 21.0067 7.94284 20.5513 8.32084 20.2093C8.70244 19.8673 9.18484 19.6963 9.76804 19.6963C10.1784 19.6963 10.533 19.7719 10.8318 19.9231V20.7547C10.4862 20.5567 10.1316 20.4577 9.76804 20.4577C9.42604 20.4577 9.15424 20.5603 8.95264 20.7655C8.75104 20.9671 8.65024 21.2371 8.65024 21.5755C8.65024 21.9175 8.74924 22.1893 8.94724 22.3909C9.14524 22.5925 9.41524 22.6933 9.75724 22.6933C9.91204 22.6933 10.065 22.6699 10.2162 22.6231V21.9373H9.62764V21.2299H11.0262V23.0659Z"
          fill="#00D37E"
        />
        <path
          d="M12.9435 23.4007H11.7015V19.7611H12.9543C13.5015 19.7611 13.9497 19.9303 14.2989 20.2687C14.6481 20.6035 14.8227 21.0211 14.8227 21.5215C14.8227 22.1047 14.6499 22.5637 14.3043 22.8985C13.9623 23.2333 13.5087 23.4007 12.9435 23.4007ZM12.9273 20.4469H12.5547V22.7203H12.9327C13.2675 22.7203 13.5249 22.6159 13.7049 22.4071C13.8885 22.1983 13.9803 21.9031 13.9803 21.5215C13.9803 21.1975 13.8885 20.9383 13.7049 20.7439C13.5213 20.5459 13.2621 20.4469 12.9273 20.4469Z"
          fill="#00D37E"
        />
        <path
          d="M11.0703 18.0007H9.76527V13.5277L8.28027 14.4187V13.0777L9.93627 12.1147H11.0703V18.0007Z"
          fill="#00D37E"
        />
        <g filter="url(#filter0_d_209_118965)">
          <ellipse cx="25.2002" cy="18" rx="9" ry="9" fill="white" />
        </g>
        <path
          d="M19.4233 23.4007H18.4189L19.5691 21.5539L18.4729 19.7611H19.4395L20.0443 20.8249L20.6221 19.7611H21.6373L20.5357 21.5593L21.7075 23.4007H20.7193L20.0605 22.2667L19.4233 23.4007Z"
          fill="#00D37E"
        />
        <path
          d="M24.4674 22.3423C24.4674 22.6699 24.3468 22.9363 24.1056 23.1415C23.8644 23.3431 23.544 23.4439 23.1444 23.4439C22.716 23.4439 22.3668 23.3683 22.0968 23.2171V22.3801C22.4244 22.6177 22.7736 22.7365 23.1444 22.7365C23.2704 22.7365 23.3748 22.7041 23.4576 22.6393C23.5404 22.5709 23.5818 22.4827 23.5818 22.3747C23.5818 22.3387 23.5764 22.3045 23.5656 22.2721C23.5548 22.2397 23.535 22.2091 23.5062 22.1803C23.4774 22.1515 23.4486 22.1281 23.4198 22.1101C23.3946 22.0885 23.355 22.0651 23.301 22.0399C23.2506 22.0111 23.2074 21.9877 23.1714 21.9697C23.1354 21.9517 23.0814 21.9265 23.0094 21.8941C22.941 21.8617 22.8852 21.8365 22.842 21.8185C22.608 21.7105 22.419 21.5773 22.275 21.4189C22.1346 21.2605 22.0644 21.0499 22.0644 20.7871C22.0644 20.4739 22.1796 20.2219 22.41 20.0311C22.6404 19.8367 22.959 19.7395 23.3658 19.7395C23.7294 19.7395 24.0426 19.8007 24.3054 19.9231V20.7007C24.0138 20.5315 23.7114 20.4469 23.3982 20.4469C23.2578 20.4469 23.1498 20.4757 23.0742 20.5333C23.0022 20.5909 22.9662 20.6647 22.9662 20.7547C22.9662 20.8447 23.0112 20.9257 23.1012 20.9977C23.1912 21.0661 23.3262 21.1399 23.5062 21.2191C23.6178 21.2695 23.7096 21.3145 23.7816 21.3541C23.8572 21.3901 23.9418 21.4423 24.0354 21.5107C24.1326 21.5755 24.2082 21.6457 24.2622 21.7213C24.3198 21.7933 24.3684 21.8833 24.408 21.9913C24.4476 22.0993 24.4674 22.2163 24.4674 22.3423Z"
          fill="#00D37E"
        />
        <path
          d="M28.116 23.0659C27.7704 23.3179 27.3348 23.4439 26.8092 23.4439C26.226 23.4439 25.7526 23.2765 25.389 22.9417C25.0254 22.6069 24.8436 22.1515 24.8436 21.5755C24.8436 21.0067 25.0326 20.5513 25.4106 20.2093C25.7922 19.8673 26.2746 19.6963 26.8578 19.6963C27.2682 19.6963 27.6228 19.7719 27.9216 19.9231V20.7547C27.576 20.5567 27.2214 20.4577 26.8578 20.4577C26.5158 20.4577 26.244 20.5603 26.0424 20.7655C25.8408 20.9671 25.74 21.2371 25.74 21.5755C25.74 21.9175 25.839 22.1893 26.037 22.3909C26.235 22.5925 26.505 22.6933 26.847 22.6933C27.0018 22.6933 27.1548 22.6699 27.306 22.6231V21.9373H26.7174V21.2299H28.116V23.0659Z"
          fill="#00D37E"
        />
        <path
          d="M30.0333 23.4007H28.7913V19.7611H30.0441C30.5913 19.7611 31.0395 19.9303 31.3887 20.2687C31.7379 20.6035 31.9125 21.0211 31.9125 21.5215C31.9125 22.1047 31.7397 22.5637 31.3941 22.8985C31.0521 23.2333 30.5985 23.4007 30.0333 23.4007ZM30.0171 20.4469H29.6445V22.7203H30.0225C30.3573 22.7203 30.6147 22.6159 30.7947 22.4071C30.9783 22.1983 31.0701 21.9031 31.0701 21.5215C31.0701 21.1975 30.9783 20.9383 30.7947 20.7439C30.6111 20.5459 30.3519 20.4469 30.0171 20.4469Z"
          fill="#00D37E"
        />
        <path
          d="M26.3701 18.0007H25.0651V13.5277L23.5801 14.4187V13.0777L25.2361 12.1147H26.3701V18.0007Z"
          fill="#00D37E"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_209_118965"
          x="6.2002"
          y="3"
          width="34"
          height="34"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2" dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.662745 0 0 0 0 0.396078 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_209_118965"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_209_118965"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_209_118965">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgOneToOneXSGD
